export const _equals = (o1: any, o2: any, ignoring: string[] = []) => {
  for (const key in o1) {
    if (ignoring.indexOf(key) !== -1) {
      continue;
    }

    if (!_equalsRecursivelly(o1[key], o2[key], key, ignoring)) {
      return false;
    }
  }

  return true;
};

const _equalsRecursivelly = (o1: any, o2: any, nestedKey: string, ignoring = []) => {
  if (typeof o1 !== 'object' && !Array.isArray(o1)) {
    // tslint:disable-next-line:triple-equals
    if (o1 != o2) {
      // tslint:disable-next-line:no-console
      // console.log(`diff: ${nestedKey} with value ${o1} is not equal to value ${o2}`);
    }

    // tslint:disable-next-line:triple-equals
    return o1 == o2;
  }

  if (Array.isArray(o1)) {
    if (o2 === undefined || !Array.isArray(o2)) {
      return false;
    }

    if (o1.length !== o2.length) {
      return false;
    }

    for (let i = 0; i < o1.length; i++) {
      // tslint:disable-next-line:no-console
      if (!_equalsRecursivelly(o1[i], o2[i], nestedKey, ignoring)) {
        return false;
      }
    }
  }

  for (const key in o1) {
    const property = Array.isArray(o1) ? `${nestedKey}` : `${nestedKey}.${key}`;

    if (ignoring.indexOf(property) !== -1) {
      continue;
    }

    if (!_equalsRecursivelly(o1[key], o2[key], property, ignoring)) {
      return false;
    }
  }

  return true;
};
